import React, { useState } from 'react';
import { FaCalendarAlt, FaMapMarkerAlt, FaChartLine, FaHandshake, FaLightbulb, FaTrophy } from 'react-icons/fa';
import './ZohoEvent.css';

// Import images from Assets directory
import Image1 from '../Assets/Zoho(1)/Images1.jpeg';
import Image2 from '../Assets/Zoho(1)/Images2.jpeg';
import Image3 from '../Assets/Zoho(1)/Images3.jpeg';
import Image4 from '../Assets/Zoho(1)/Images4.jpeg';
import Image5 from '../Assets/Zoho(1)/Images5.jpeg';
import Image6 from '../Assets/Zoho(1)/Images6.jpeg';
import Image7 from '../Assets/Zoho(1)/Images7.jpeg';
import Image8 from '../Assets/Zoho(1)/Images8.jpeg';
import Image9 from '../Assets/Zoho(1)/Images9.jpeg';
import Image10 from '../Assets/Zoho(1)/Images10.jpeg';
import Image11 from '../Assets/Zoho(1)/Images11.jpeg';
import Image12 from '../Assets/Zoho(1)/Images12.jpeg';
import Image13 from '../Assets/Zoho(1)/Images13.jpeg';
import Image14 from '../Assets/Zoho(1)/Images14.jpeg';
import Image15 from '../Assets/Zoho(1)/Images15.jpeg';
import Image16 from '../Assets/Zoho(1)/Images16.jpeg';
import Image17 from '../Assets/Zoho(1)/Images17.jpeg';
import Image18 from '../Assets/Zoho(1)/Images18.jpeg';
import Image19 from '../Assets/Zoho(1)/Images19.jpeg';
import Image20 from '../Assets/Zoho(1)/Images20.jpeg';

const ZohoEvent = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);

  // Event gallery images
  const galleryImages = [
    Image1, Image2, Image3, Image4, Image5, Image6, Image7, Image8, Image9, Image10,
     Image11, Image12, Image13, Image14, Image15, Image16, Image17,
      Image18, Image19, Image20
  ];

  const openLightbox = (image, index) => {
    setLightboxIndex(index);
    setLightboxOpen(true);
    document.body.style.overflow = 'hidden';
    // Add event listener for keyboard navigation
    document.addEventListener('keydown', handleKeyDown);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      closeLightbox();
    } else if (e.key === 'ArrowRight') {
      setLightboxIndex((prev) => (prev === galleryImages.length - 1 ? 0 : prev + 1));
    } else if (e.key === 'ArrowLeft') {
      setLightboxIndex((prev) => (prev === 0 ? galleryImages.length - 1 : prev - 1));
    }
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    document.body.style.overflow = 'auto';
    // Remove event listener when lightbox is closed
    document.removeEventListener('keydown', handleKeyDown);
  };
  
  const nextLightboxImage = (e) => {
    e.stopPropagation();
    setLightboxIndex((prev) => (prev === galleryImages.length - 1 ? 0 : prev + 1));
  };
  
  const prevLightboxImage = (e) => {
    e.stopPropagation();
    setLightboxIndex((prev) => (prev === 0 ? galleryImages.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === galleryImages.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? galleryImages.length - 1 : prev - 1));
  };
  
  // Touch event handlers for mobile swipe functionality
  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
  };
  
  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };
  
  const handleTouchEnd = () => {
    if (touchStart - touchEnd > 100) {
      // Swipe left - go to next slide
      nextSlide();
    }
    
    if (touchStart - touchEnd < -100) {
      // Swipe right - go to previous slide
      prevSlide();
    }
  };

  return (
    <div className="event-page">
      {/* Header Section */}
      <div className="event-header">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h1 className="event-title">US Business Incorporation Zoho Books & Zoho Payroll Event</h1>
              <p className="event-subtitle">
                Hosted by BooksComply in collaboration with Zoho at Novotel Hotel, Ahmedabad.
              </p>
              <div className="event-details">
                <div className="event-detail-item">
                  <FaCalendarAlt className="event-icon" />
                  <span>3rd September 2025</span>
                </div>
                <div className="event-detail-item">
                  <FaMapMarkerAlt className="event-icon" />
                  <span>Novotel Hotel, Ahmedabad</span>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="event-header-image">
                <img src={Image1} alt="Zoho Books Event at Novotel" className="img-fluid rounded shadow" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* About the Event */}
      <section className="event-about">
        <div className="container">
          <h2 className="section-title">About the Event</h2>
          <div className="event-about-content">
            <p>
              On 3rd September 2025, BooksComply successfully organized an exclusive event in collaboration with Zoho Finance at Novotel Hotel, Ahmedabad.
              The event brought together industry professionals, accountants, tax consultants, and business owners to explore how Zoho Books can simplify accounting, compliance, and business automation.
            </p>
          </div>
        </div>
      </section>

      {/* Key Highlights */}
      <section className="event-highlights">
        <div className="container">
          <h2 className="section-title">Key Highlights</h2>
          <div className="row">
            <div className="col-md-6 col-lg-3">
              <div className="highlight-card">
                <FaChartLine className="highlight-icon" />
                <h3>Live Demo</h3>
                <p>Hands-on walkthrough of BooksComply Portal features.</p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="highlight-card">
                <FaHandshake className="highlight-icon" />
                <h3>Client Benefits</h3>
                <p>Practical insights on how U.S. business incorporation can establish credibility, provide legal protection, unlock tax advantages, and create growth opportunities for clients.</p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="highlight-card">
                <FaLightbulb className="highlight-icon" />
                <h3>Knowledge Sharing</h3>
                <p>Discussion on cloud accounting and compliance trends.</p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="highlight-card">
                <FaTrophy className="highlight-icon" />
                <h3>BooksComply's Role</h3>
                <p>Showcased outsourcing, automation, and compliance support services.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Event Gallery */}
      <section className="event-gallery">
        <div className="container">
          <h2 className="section-title">Event Gallery</h2>
          
          {/* Curved Carousel Display */}
          <div className="curved-carousel-container">
            <div 
              className="carousel-track"
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
            >
              {galleryImages.map((image, index) => (
                <div 
                  key={index} 
                  className={`carousel-slide ${index === currentSlide ? 'active' : ''} ${index === (currentSlide - 1 + galleryImages.length) % galleryImages.length ? 'prev' : ''} ${index === (currentSlide + 1) % galleryImages.length ? 'next' : ''}`}
                  onClick={() => openLightbox(image, index)}
                >
                  <img 
                    src={image} 
                    alt={`Event photo ${index + 1}`} 
                    className="img-fluid"
                    draggable="false"
                  />
                </div>
              ))}
            </div>
            
            {/* Carousel Navigation */}
            <div className="carousel-controls">
              <button className="carousel-control-btn" onClick={prevSlide}>
                &#8249;
              </button>
              <button className="carousel-control-btn" onClick={nextSlide}>
                &#8250;
              </button>
            </div>
            
          </div>
          
          {/* Gallery Grid - Masonry Style */}
          <div className="gallery-grid mt-5">
            <h3 className="text-center mb-4">All Event Photos</h3>
            
            {/* Mobile Gallery - 2 columns */}
            <div className="d-block d-md-none">
              <div className="row g-3">
                <div className="col-6">
                  {galleryImages.filter((_, i) => i % 2 === 0).map((image, index) => {
                    const actualIndex = index * 2;
                    return (
                      <div key={index} className="gallery-item mb-3">
                        <img 
                          src={image} 
                          alt={`Event photo ${actualIndex + 1}`} 
                          onClick={() => openLightbox(image, actualIndex)}
                          className="img-fluid rounded cursor-pointer shadow-sm"
                        />
                      </div>
                    );
                  })}
                </div>
                <div className="col-6">
                  {galleryImages.filter((_, i) => i % 2 === 1).map((image, index) => {
                    const actualIndex = index * 2 + 1;
                    return (
                      <div key={index} className="gallery-item mb-3">
                        <img 
                          src={image} 
                          alt={`Event photo ${actualIndex + 1}`} 
                          onClick={() => openLightbox(image, actualIndex)}
                          className="img-fluid rounded cursor-pointer shadow-sm"
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            
            {/* Desktop Gallery - 3 columns */}
            <div className="d-none d-md-block">
              <div className="row g-4">
                <div className="col-md-4">
                  {galleryImages.filter((image, i) => i % 3 === 0).map((image, index) => (
                    <div key={index} className="gallery-item mb-4">
                      <img 
                        src={image} 
                        alt={`Event photo ${index * 3 + 1}`} 
                        onClick={() => openLightbox(image, index * 3)}
                        className="img-fluid rounded cursor-pointer shadow hover-scale"
                      />
                    </div>
                  ))}
                </div>
                <div className="col-md-4">
                  {galleryImages.filter((_, i) => i % 3 === 1).map((image, index) => (
                    <div key={index} className="gallery-item mb-4">
                      <img 
                        src={image} 
                        alt={`Event photo ${index * 3 + 2}`} 
                        onClick={() => openLightbox(image, index * 3 + 1)}
                        className="img-fluid rounded cursor-pointer shadow hover-scale"
                      />
                    </div>
                  ))}
                </div>
                <div className="col-md-4">
                  {galleryImages.filter((_, i) => i % 3 === 2).map((image, index) => (
                    <div key={index} className="gallery-item mb-4">
                      <img 
                        src={image} 
                        alt={`Event photo ${index * 3 + 3}`} 
                        onClick={() => openLightbox(image, index * 3 + 2)}
                        className="img-fluid rounded cursor-pointer shadow hover-scale"
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="event-testimonials">
        <div className="container">
          <h2 className="section-title">Testimonials</h2>
          <div className="testimonial-card">
            <div className="testimonial-content">
              <p>"Informative and engaging session. Great insights into the process of U.S. business incorporation and its benefits for entrepreneurs."</p>
              <div className="testimonial-author">— Kaushik Panchal</div>
            </div>
          </div>
        </div>
      </section>

      {/* Enhanced Lightbox with Navigation */}
      {lightboxOpen && (
        <div className="lightbox" onClick={closeLightbox}>
          <span className="lightbox-close" onClick={closeLightbox}>&times;</span>
          
          <div className="lightbox-container" onClick={(e) => e.stopPropagation()}>
            <img 
              src={galleryImages[lightboxIndex]} 
              alt={`Event photo ${lightboxIndex + 1}`} 
              className="lightbox-content" 
            />
            
            <div className="lightbox-caption">
              Photo {lightboxIndex + 1} of {galleryImages.length}
            </div>
            
            <button className="lightbox-nav lightbox-prev" onClick={prevLightboxImage}>
              &#8249;
            </button>
            <button className="lightbox-nav lightbox-next" onClick={nextLightboxImage}>
              &#8250;
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ZohoEvent;
